// extracted by mini-css-extract-plugin
export default {"container":"AvatarUpload_container__G-ujd","avatar":"AvatarUpload_avatar__eRgG3","button":"AvatarUpload_button__V+mgn","delete":"AvatarUpload_delete__1RhoO"};